import { render, staticRenderFns } from "./sku.vue?vue&type=template&id=e3156ed8&scoped=true&"
import script from "./sku.vue?vue&type=script&lang=js&"
export * from "./sku.vue?vue&type=script&lang=js&"
import style0 from "./sku.vue?vue&type=style&index=0&id=e3156ed8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3156ed8",
  null
  
)

export default component.exports